import { Provider } from "jotai";
import { type PropsWithChildren } from "react";

import { store } from "../../internal/store";
import { useCollabRegistryLoader } from "../hooks/useCollabRegistryLoader";
import { useDocsListLoader } from "../hooks/useDocsListLoader";
import { useDocumentAutoLoader } from "../hooks/useDocumentLoader";
import { useFileWatcherLoader } from "../hooks/useFileWatcherLoader";
import { useProductAnalytics } from "../hooks/useProductAnalytics";
import { useWorkflowsLoader } from "../hooks/useWorkflowsLoader";

type JotaiProviderProps = PropsWithChildren<{
	/**
	 * When true, skips all background effects (docs list fetching, document auto-loader,
	 * collab registry, file watcher). The Jotai store is still available, but no automatic
	 * data fetching or subscriptions are started. Used by the web app, which only renders
	 * single published documents and fetches data directly via SSR / docsapi.
	 */
	minimal?: boolean;
}>;

const FullEffects: React.FC = () => {
	// CRITICALLY IMPORTANT: Start these effects at app startup, and NEVER EVER TERMINATE
	// THEM, EVER.
	useDocsListLoader();
	useDocumentAutoLoader();
	useCollabRegistryLoader();
	useFileWatcherLoader();
	useWorkflowsLoader();
	useProductAnalytics();

	return null;
};

export const JotaiProvider: React.FC<JotaiProviderProps> = ({ minimal, children }) => {
	return (
		<Provider store={store}>
			{!minimal && <FullEffects />}
			{children}
			{/* <JotaiDevtools /> */}
		</Provider>
	);
};
